import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';
import swipeableGridDefaults from '../SwipeableGrid/SwipeableGrid.defaults.js';

export default {
  ...cloneDeep(baseDefaults),
  swipeableGrid: cloneDeep(swipeableGridDefaults),
  ratio: '1/1',
  customHeight: {
    desktop: {
      unit: 'px',
      value: 100,
    },
  },
  objectFit: 'cover',
  items: [
    {
      title: 'Your Title',
      src: 'https://res.cloudinary.com/ditbeukyz/image/upload/v1605878200/Resources/placeholder.svg?cratio=16x9',
      id: 'random',
    },
  ],
  horizontalPadding: {
    desktop: 0,
  },
  verticalPadding: {
    desktop: 0,
  },
  backgroundColor: '',
  lightbox: false,
};
